__turbopack_context__.v({
  "cardHeader": "CardHeader-module__jZ5LZq__cardHeader",
});
